import { render, staticRenderFns } from "./AreaCharts.vue?vue&type=template&id=0b51cc54&"
import script from "./AreaCharts.vue?vue&type=script&lang=js&"
export * from "./AreaCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports